import { render, staticRenderFns } from "./salesData.vue?vue&type=template&id=1db2fb00"
import script from "./salesData.vue?vue&type=script&lang=js"
export * from "./salesData.vue?vue&type=script&lang=js"
import style0 from "./salesData.vue?vue&type=style&index=0&id=1db2fb00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports